import React from 'react';
import { Redirect } from 'react-router-dom';

class DelayedRedirect extends React.Component {
	/**
     * 
     * @param {*} props 
     */
	constructor(props) {
		super(props);
		this.state = {
			shouldRedirect: false
		};
	}
	/**
     * 
     */
	componentWillMount() {
		setTimeout(() => {
			this.setState({ shouldRedirect: true });
		}, this.props.delay || 3000);
	}

	/**
     * 
     */
	render() {
		return this.state.shouldRedirect === true ? <Redirect to={this.props.to} /> : null;
	}
}
/**
 * 
 */
export default DelayedRedirect;
